export default "__VITE_ASSET__BcKQROg6__"